import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-ethernet100g40g',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-ethernet100g40g.component.scss']
})
export class NestedSidebarEthernet100g40gComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  pdf = {
    pdfTitle: '100G/40G Ethernet Poster<br>&nbsp;',
    pdfimg: './assets/images/sidebar/100geposter.webp',
    url: '100gposter',
    opt: 'BUTTON.DOWNLOADREQ',
    width: '8418',
    height: '5658'
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
  }

}
